export default __webpack_public_path__ + "static/avatar-tag-2-do-dark-1bdc73234361d578ee25314e80a64be303724d6ed8aec3c3cdb7d67816930602.png";